import { IActivityItem } from "@rentiohq/shared-frontend/dist/types/activity.types";
import { startOfDay } from "@rentiohq/shared-frontend/dist/utils/date-fns.utils";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import {
  Box,
  Button,
  MainCard,
  Typography,
  SpinningLoader,
} from "@rentiohq/web-shared-next/dist/ui-components";
import {
  EButtonColors,
  EButtonVariants,
} from "@rentiohq/web-shared-next/dist/utils/types/button";
import groupBy from "lodash/groupBy";
import { ActivityGroup } from "../../../../components/ActivityGroup";

interface IProps {
  activities: IActivityItem[];
  isLoading: boolean;
  fetchMore: () => void;
  activitiesCount?: number;
}

export const PaymentHistory = ({
  activities,
  isLoading,
  fetchMore,
  activitiesCount = 0,
}: IProps) => {
  const renderActivities = () => {
    const groupedActivities = groupBy(activities, (activity: any) =>
      startOfDay(new Date(activity.datetime)),
    );

    const sortedActivitiesKeys = Object.keys(groupedActivities).sort(
      (a, b) => new Date(b).getTime() - new Date(a).getTime(),
    );

    return (
      <Box>
        {sortedActivitiesKeys.map((groupedDate: any) => {
          return (
            <ActivityGroup
              groupedDate={groupedDate}
              groupedActivities={groupedActivities[groupedDate]}
            />
          );
        })}
      </Box>
    );
  };

  const renderLoadMore = () => {
    if (activitiesCount <= activities.length) {
      return null;
    }

    if (isLoading) {
      return null;
    }

    return (
      <Button
        onClick={fetchMore}
        variant={EButtonVariants.Text}
        color={EButtonColors.Success}
      >
        {getLocalizedText("system.load_more")}
      </Button>
    );
  };

  return (
    <Box>
      <Typography variant="h6" mb={1}>
        {getLocalizedText(
          "payments.payment_requests.history.heading",
        ).toUpperCase()}
      </Typography>
      <MainCard>
        {renderActivities()}
        {renderLoadMore()}
        {isLoading && <SpinningLoader />}
      </MainCard>
    </Box>
  );
};
